export const SET_STEP = 'nme.stepper.setStep';
export const SET_TOTAL_STEPS = 'nme.stepper.setTotalSteps';
